import * as React from "react";
const SvgFiRrPizzaSlice = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-pizza-slice_svg__a)">
      <path d="M23.2.8a2.72 2.72 0 0 0-2.9-.624L3.155 6.929a4.976 4.976 0 0 0-3 5.824 15.86 15.86 0 0 0 11.094 11.1 4.98 4.98 0 0 0 5.825-3.01l6.758-17.171A2.71 2.71 0 0 0 23.2.8M11.746 21.91a13.8 13.8 0 0 1-9.656-9.656 2.95 2.95 0 0 1 1.265-3.18 11.987 11.987 0 0 0 11.569 11.572 2.95 2.95 0 0 1-3.178 1.265m4.027-3.226c-6.191-.1-10.355-4.265-10.456-10.457l15.693-6.18a.72.72 0 0 1 .77.17.7.7 0 0 1 .182.747l-.662 1.68c-5.758-1.98-8.942 6.21-3.413 8.669zm2.847-7.232a2.654 2.654 0 0 1 1.943-4.935z" />
      <path d="M11 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
    </g>
    <defs>
      <clipPath id="fi-rr-pizza-slice_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPizzaSlice;
